import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import LPBsGaCTmagProject from "../../Assets/Projects/LPBsGaCTmagProject.png";
import AptecnyiSklad from "../../Assets/Projects/AptecnyiSklad.png";
import gotocinema from "../../Assets/Projects/gotocinema.png";
import nevusBot from "../../Assets/Projects/NevusBot.png";
import ChatGUIcpp from "../../Assets/Projects/ChatGUIcpp.png";
import government_procurement from "../../Assets/Projects/government-procurement.png";
import PyDiplom from "../../Assets/Projects/PyDiplom.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Мои <strong className="purple">проекты </strong>
        </h1>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={nevusBot}
              isBlog={false}
              title="Telegram бот для идентификации меланомы"
              description="Сверточная нейросеть (Convolutional Neural Networks, CNN) обучена на Melanoma Cancer Image Dataset (13 900 фото высокого разрешения злокачественных и доброкачественных образований) с помощью библиотек Tensorflow и Keras."
              ghLink="https://github.com/Vofanchik/nevusBot"
              demoLink="https://t.me/nevus_malignization_bot"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={LPBsGaCTmagProject}
              isBlog={false}
              title="Система учёта экспериментов лаборатории первичного биоскрининга"
              description="Информационная система на Python, rdKit Qt6, R и Java. Включает в себя:     
                базу данных исследований,
                графический интерфейс,
                средство автоматического расчёта основных показателей эффективности химических соединений на основе входных данных эксперимента,
                средство графического моделирования химических соединений,
                средство проектирования графиков статистической обработки,
                средство анализа и построения карт подобия химических соединений"
              ghLink="https://github.com/Vofanchik/LPBsGaCTmagProject"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gotocinema}
              isBlog={false}
              title="Идём в кино"
              description="Сервис для онлайн бронирования билетов в кино на React, express и sqlite. Возможности администратора:
                  создание или редактирование залов,
                  создание или редактирование списка фильмов,
                  настройка цен,
                  создание или редактирование расписания сеансов фильмов. Возможности гостя:
                  просмотр расписания,
                  просмотр списка фильмов,
                  выбор места в кинозале,
                  бронирование билета на конкретную дату."
              ghLink="https://github.com/Vofanchik/gotocinema"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={AptecnyiSklad}
              isBlog={false}
              title="Аптечный склад"
              description="Десктопное приложение для учета материальных ценностей в аптечной организации на Python, Qt5 и SQLlite3.
                Функции: импорт данных в базу программы из форматов .xlsx, .ods,
                создание отдельных групп материальных ценностей;
                быстрый поиск учётных единиц с автозаполнением и редактирование;
                добавление операций по приходу-выбытию;
                автоматическая генерация остатков складских запасов, а также их экспорт в форматы .docx и .odt;
                отображение информации об операциях с фильтрацией по дате"
              ghLink="https://github.com/Vofanchik/AptecnyiSklad"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ChatGUIcpp}
              isBlog={false}
              title="Клиент-сервенрый GUI мессенджер на C++/Qt5"
              description="Клиентаская часть:
                функции авторизации и регистрации;
                приватные сообщения;
                общие сообщения.
                Серверная часть:
                наличие окна просмотра всех сообщений и списка пользователей;
                возможность отключения и бана пользователей"
              ghLink="https://github.com/Vofanchik/ChatGUIcpp"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={government_procurement}
              isBlog={false}
              title="Поиск поставщиков ЕИС в сфере закупок"
              description="Простое приложение на Tkinter для поиска контактов релевантных поставщиков по объекту закупки и региону. 
                  Приложение использует API ЕГРЮЛ, ЕИС в сфере закупок и ГосЗатраты (позволяет делать до 100 запросов в сутки с одного IP)"
              ghLink="https://github.com/Vofanchik/government_procurement"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={PyDiplom}
              isBlog={false}
              title="Backend-приложение для автоматизации закупок на Django Rest Framework"
              description="API позволяет клиентам искать товары по параметрам, добавлять их в корзину и формировать заказ, 
              а поставщикам редактировать ассортимент и экспортировать его из .yaml"
              ghLink="https://github.com/Vofanchik/PyDiplom"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
